module.exports = __webpack_public_path__ + "static/media/004-beach.8f7fd3b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/004-beach.png
// module id = 648
// module chunks = 0